import React from "react";
import Layout from "../layout/Layout";
import { useSeoData } from "../templates/seo/Main";
import ExploreInDelhiTemplate from "../templates/explore-in-delhi/Main";

const ExploreInDelhiPage = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext;
  return (
    <Layout crumbs={crumbs} crumbLabel={"Explore In Delhi"}>
      <ExploreInDelhiTemplate />
    </Layout>
  );
};

export default ExploreInDelhiPage;

export const Head = () => {
  const { meta_title, meta_description, meta_keyword } = useSeoData("explore-in-delhi");
  return (
    <>
      <title>{meta_title}</title>
      <meta name="description" content={meta_description?.data?.meta_description} />
      <meta name="keywords" content={meta_keyword?.data?.meta_keyword} />
    </>
  );
};
